import { Injectable, InjectionToken, Injector } from '@angular/core';

export const PARAM_TRANSFORMERS = new InjectionToken('logging-param-transformers');

/**
 * Used to add additional logging details to log
 * messages
 * @export
 * @abstract
 * @class LoggerParamsTransformer
 */
@Injectable()
export abstract class LoggerParamsTransformer {
  private _initizialied = false;

  /**
   * Returns true if the initialize function has been called.
   *
   * @readonly
   * @type {boolean}
   * @memberof LoggerParamsTransformer
   */
  public get initialized(): boolean {
    return this._initizialied;
  }

  /**
   * Creates an instance of LoggerParamsTransformer.
   * Also calls initialize() after a setTimeout, to make sure DI has been initialized
   * @param {Injector} injector Injector for doing DI operations. To be used in initialize()
   * @memberof LoggerParamsTransformer
   */
  constructor(protected injector: Injector) {
    setTimeout(() => {
      this.initialize();
      this._initizialied = true;
    });
  }

  /**
   * Override this function to perform all injection (using this.injector)
   * Setup of the transformer (actions or selects on a store, async operations, etc.) should be done here as well
   *
   * @memberof LoggerParamsTransformer
   */
  initialize(): void {}

  /**
   * This function must be overrided to provide teh extra details for logging
   *
   * @abstract
   * @returns {{ [key: string]: any }}
   * @memberof LoggerParamsTransformer
   */
  // tslint:disable-next-line
  abstract getParams(): { [key: string]: any };
}
